import { render } from "./Accordion.vue?vue&type=template&id=74676074&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=74676074&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\diafischchen-webpage\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74676074"]])

export default __exports__